import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EAccess } from 'src/app/access/access.model';

import { MsalRedirectComponent } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { AccessGuard } from './access/access-guard';
import { signInGuard } from './core/guards/sign-in.guard';
import { UserGuard } from './core/guards/user.guard';
import { LayoutComponent } from './layouts/layout.component';
import { BaseComponent } from './base/base.component';

const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    // MsalGuard when email-first sign-in is off; with it on, signed-out visitors go to /sign-in.
    canActivate: [signInGuard],
    children: [
      {
        path: '',
        component: LayoutComponent,
        canActivate: [UserGuard, AccessGuard],
        data: {
          accessControllers: [EAccess.Authentication],
          showLoader: true
        },
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
      },
    ]
  },
  {
    // Email-first sign-in page (organisation sign-in / SSO). Deliberately outside the guard above.
    path: 'sign-in',
    loadComponent: () => import('./pages/sign-in/sign-in.component').then(m => m.SignInComponent)
  },
  {
    // Needed for handling redirect after login
    path: 'auth',
    component: MsalRedirectComponent,
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? 'enabledNonBlocking'
          : 'disabled',
      scrollPositionRestoration: 'top',
      enableTracing: false
    })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
